<!-- 区域摄像机tree-->
<template>
  <div class="deviceCamera_wrap">
    <div class="deviceCamera_top">
      <div class="video-search">
        <el-input
          placeholder="请输入"
          prefix-icon="el-icon-search"
          v-model="searchForm.devicesName"
          clearable
        >
        </el-input>
        <el-select
          v-model="searchForm.devicesType"
          placeholder="请选择"
          style="width: 50%"
        >
          <el-option
            v-for="item in videoType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="video-check">
        <label>已选： {{ checkedDevice.length }} </label>

        <div>
          <el-button
            type="info"
            :title="!checkedDevice.length && '请勾选摄像机设备后操作'"
            :disabled="checkedDevice.length == 0"
            @click="handlePlayBatch"
            style="padding: 6px 14px !important"
            >批量播放</el-button
          >
          <el-button
            type="info"
            :title="!checkedDevice.length && '请勾选摄像机设备后操作'"
            :disabled="checkedDevice.length == 0"
            @click="handleCollection"
            style="padding: 6px 14px !important"
            >添加到收藏夹</el-button
          >
        </div>
      </div> -->
    </div>
    <div
      class="deviceCamera_container"
      v-loading="treeLoading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
    >
      <el-scrollbar ref="scrollBar" class="scroll-bar">
        <el-tree
          class="deviceTree"
          ref="appDeviceGroupTree"
          :data="cameraTree"
          node-key="id"
          :props="defaultProps"
          :show-checkbox="multiCheck"
          highlight-current
          :default-expanded-keys="expandedKeys"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterNode"
          @check="handleCheckNode"
        >
          <!-- :draggable="data.nodeType == 'device' ? true : false" -->
          <!-- @dragstart="dragStart($event, data)" -->
          <div
            unselectable="on"
            onselectstart="return false;"
            style="-moz-user-select: none"
            class="node"
            :title="data.name"
            slot-scope="{ data }"
            :class="[
              {
                'out-line': parseInt(data.status) != 1 && data.nodeType === 'device',
              },
              data.nodeType == 'device' ? 'showDrag' : '',
            ]"
          >
            <i
              v-if="data.nodeType === 'device'"
              class="iconfont-lunan icon-lunan-shexiangtou"
            >
            </i>
            <span
              title="离线"
              v-if="parseInt(data.status) != 1 && data.nodeType === 'device'"
              class="close"
              >x</span
            >
            <span class="node-label">{{ data.name }}</span>
            <span
              title="播放中"
              v-if="liveDeviceIds.includes(data.thirdCameraId)"
              class="node-state-live"
            >
              <img src="@src/common/assets/images/直播中.png" alt="" />
            </span>
            <span
              title="回放中"
              v-if="backDeviceIds.includes(data.thirdCameraId)"
              class="node-state-back"
            >
              <img src="@src/common/assets/images/视频回放.png" alt="" />
            </span>
            <span v-show="data.nodeType !== 'device'" class="node-onLine">{{
              getInlinePercentage(data)
            }}</span>
          </div>
        </el-tree>
      </el-scrollbar>
    </div>
    <!-- <appPanel
      :width="342"
      position="left"
      class="app-panel"
      :isExpand="showCollect"
      @cancel="handleCloseAppPanel"
      title="收藏夹"
    >
      <video-collect
        v-if="showCollect"
        @handleCollectUpdate="
          () => {
            $emit('handleCollectUpdate');
          }
        "
        :actionType="actionType"
        :collectDevice="checkedDevice"
      ></video-collect>
    </appPanel> -->
  </div>
</template>
<script>
import videoCollect from "./video-collect";
// import appPanel from "@src/components/business/app-panel/index.vue";
import busVue from "@/common/utils/busVue";
import { api } from "../api.js";
import { Cache } from "$utils";
export default {
  props: {
    // multiCheck: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  watch: {
    "searchForm.devicesName": {
      handler(val) {
        this.$refs.appDeviceGroupTree.filter(val);
      },
    },
    "searchForm.devicesType": {
      handler(val) {
        this.searchForm.devicesName = "";
        this.queryDevice();
      },
      immediate: true,
    },
  },
  components: {
    // appPanel,
    // videoCollect,
  },
  data() {
    return {
      treeLoading: false,
      multiCheck: true,
      actionType: 0,
      showCollect: false,
      defaultCheckedKeys: [],
      videoType: [
        { label: "设备组", value: 0 },
        { label: "区域树", value: 1 },
      ],
      searchForm: {
        devicesName: "",
        devicesType: 0,
      },
      cameraTree: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "id",
      },
      checkedDevice: [], //选中的设备
      checkedArea: [], //选中的区域
      expandedKeys: [], // 默认展开的数组
      showTree: true,
      deviceName: "",
      thirdCameraId: "",
      clickNum: 0,
      liveDeviceIds: [], //直播的设备集合
      backDeviceIds: [], //回放的设备集合
    };
  },
  created() {
    // 接收设备播放的回调
    busVue.$on("handleVideoPlayLiveCallBack", (info) => {
      // console.log(info);
      if (info.state == 1) {
        info.videoType == "live"
          ? this.liveDeviceIds.push(info.thirdCameraId)
          : this.backDeviceIds.push(info.thirdCameraId);
      } else {
        // 实况,录像均清除
        let name =
          info.videoType == "live"
            ? "liveDeviceIds"
            : info.videoType == "back"
            ? "backDeviceIds"
            : "";
        if (!name) {
          let indexLive = this.liveDeviceIds.indexOf(info.thirdCameraId);
          let indexBack = this.backDeviceIds.indexOf(info.thirdCameraId);
          this.liveDeviceIds.splice(indexLive, 1);
          this.backDeviceIds.splice(indexBack, 1);
        } else {
          // 清除单个场景:实况:录像
          let index = this[name].indexOf(info.thirdCameraId);
          this[name].splice(index, 1);
        }
      }
    });
  },
  mounted() {},
  beforeDestroy() {
    busVue.$off("handleVideoPlayLiveCallBack");
  },
  methods: {
    handleCloseAppPanel() {
      this.showCollect = false;
      this.actionType = 0;
      // this.resetSelect();
    },
    // 查询摄像机资源
    queryDevice() {
      let url =
        this.searchForm.devicesType == 0 ? api.queryCameraTree : api.queryCameraList;
      let params = {
        deviceType: 10,
      };
      this.treeLoading = true;
      this.$fetch(url, params).then((response) => {
        this.treeLoading = false;
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let result = response.returnObj;
          this.expandedKeys = [result[0].id]; //默认展开第一级
          this.cameraTree = result;
          console.log(this.cameraTree);
        }
      });
    },
    dragStart(e, item) {
      if (item.nodeType == "area") {
        e.stopPropagation();
        return;
      } else {
        e.dataTransfer.setData("item", JSON.stringify(item));
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    cameraIcon(data) {
      switch (data.ability) {
        case "0":
          return "";
        case "1":
          return "icon-lunan-renyuanbukong";
        case "2":
          return "icon-lunan-cheliangbukong";
        // case '3':return 'icon iconfont icon-b_icon__cam_hem';
        default:
          return "";
      }
    },
    // 区域，楼栋图标
    areaIcon(data) {
      const account = Cache.get("CACHE_USER_INFO");
      if (account.parkInfo.areaDevGroupCode === data.id) {
        return this.$config.fontFamily + " ioc-Build";
      } else {
        return "el-icon-office-building";
      }
    },
    // tree多选
    handleCheckNode(node, checkData) {
      let checkNodes = checkData.checkedNodes; // 当前被选中节点数组
      this.checkedArea = []; //选中的区域
      this.checkedDevice = []; //选中的设备
      checkNodes.forEach((item) => {
        if (item.nodeType == "device") {
          this.checkedDevice.push(item);
        } else {
          this.checkedArea.push(item);
        }
      });
      // this.$emit("cameraData", this.checkedDevice, this.checkedArea);
    },
    // 在线率
    getInlinePercentage(data) {
      data.inlineCount = data.inlineCount || 0;
      data.totalCount = data.totalCount || 0;
      let percentage = parseInt((data.inlineCount / data.totalCount) * 100);
      return `【${data.inlineCount}/${data.totalCount}；${percentage || 0}%】`;
    },
    // 批量播放
    handlePlayBatch() {
      busVue.$emit("handleChooseCamera", [...this.checkedDevice], "batch");
    },
    // 添加到收藏夹
    handleCollection() {
      this.actionType = 2;
      this.showCollect = true;
    },
    //重置tree选中
    resetSelect() {
      this.$refs.appDeviceGroupTree.setCheckedNodes([]);
      this.checkedDevice = [];
    },
    // 双击
    deviceChoose(nodeData) {
      console.log(nodeData);
      if (nodeData.nodeType == "device") {
        if (nodeData.status != 1) {
          this.$message.warning(this.$t("business.message.offline"));
          return;
        }
        busVue.$emit("handleChooseCamera", nodeData);
      } else {
        this.$message.warning("请选中摄像机设备播放");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.deviceCamera {
  &_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .app-panel {
      z-index: 3;
      top: -44px;
      left: -16px;
      height: calc(100% + 78px);
    }
  }
  &_top {
    .video-search {
      display: flex;
      margin-top: 16px;
    }
    .video-check {
      display: flex;
      justify-content: space-between;
      margin: 8px 0px 16px;
      align-items: center;
    }
  }
  &_container {
    height: calc(100% - 70px);
    position: relative;
    .scroll-bar {
      height: 100%;
      padding-bottom: 10px;
    }
    .deviceTree {
      .node {
        position: relative;
        display: flex;
        width: 85%;
        height: 32px;
        line-height: 32px;
        .node-cover {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .node-label {
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // word-break: break-all;
        }
        .node-state {
          &-live {
            position: absolute;
            right: 5px;
          }
          &-back {
            position: absolute;
            right: 30px;
          }
        }
        .node-onLine {
          // margin-left: 5px;
        }
        &.out-line {
          i {
            color: #757373;
          }
          .node-label {
            color: black;
          }
          .close {
            background: red;
            border-radius: 50%;
            width: 17px;
            height: 17px;
            line-height: 17px;
            text-align: center;
            padding: 0px;
            -webkit-transform: scale(0.7);
            transform: scale(0.7);
            font-size: 16px;
            position: absolute;
            bottom: 1px;
            left: 4px;
          }
        }
        .camera-type-icon {
          text-align: right;
          flex: 1;
          margin-right: 10px;
        }
      }
    }
    .showIcon {
      @include set_theme_color(color, main-theme-color);
      &:hover {
        color: #fff;
      }
    }
    .showDrag {
      // max-width: 260px;
    }
    .area-node-icon {
      font-size: 16px;
      margin-right: 5px;
    }
    .iconfont-lunan {
      margin-right: 5px;
    }
  }
}

/deep/.el-tree-node__content {
  height: 32px;
}
/deep/ .el-tree-node > .el-tree-node__children {
  overflow: visible;
}
</style>
